import { useEffect, useRef, useState, type FormEvent } from 'react';
import { Link, useLocation, useNavigate } from 'react-router';

import { useAuth } from '@/api/auth';

import '../market/market.css';
import './login.css';

export function ResetPasswordScreen() {
  const { requestPasswordReset, confirmPasswordReset } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const token = new URLSearchParams(location.hash.replace(/^#/, '')).get('token') ?? '';
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const active = useRef(true);
  const epoch = useRef(0);

  useEffect(() => {
    active.current = true;
    epoch.current += 1;
    setBusy(false);
    setMessage(null);
    setError(null);
    return () => { active.current = false; epoch.current += 1; };
  }, [token]);

  async function submit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    if (token && password !== confirm) {
      setError('Пароли не совпадают');
      return;
    }
    const attempt = ++epoch.current;
    const current = () => active.current && attempt === epoch.current;
    setBusy(true);
    setError(null);
    try {
      if (token) {
        await confirmPasswordReset(token, password);
        if (!current()) return;
        navigate('/account/security', { replace: true });
      } else {
        const result = await requestPasswordReset(email);
        if (!current()) return;
        setMessage(result.message);
      }
    } catch (cause) {
      if (!current()) return;
      setError(cause instanceof Error ? cause.message : 'Не удалось выполнить сброс');
      setBusy(false);
    }
  }

  return <div className="market-page login-page"><section className="login-intro"><div className="login-brand"><span>TRAVEL</span><strong>CORTEX</strong><em>recovery</em></div><div className="login-message"><span className="market-eyebrow">Восстановление доступа</span><h1>{token ? 'Задайте новый пароль.' : 'Получите одноразовую ссылку.'}</h1><p>После смены пароля все прежние активные сессии будут отозваны.</p></div></section><section className="login-access"><form onSubmit={submit} className="login-form"><div className="login-form-heading"><h2>{token ? 'Новый пароль' : 'Сброс пароля'}</h2></div>{message ? <p role="status" className="login-notice">{message}</p> : null}{token ? <><label className="login-password" htmlFor="reset-password"><span>Пароль</span><input id="reset-password" type="password" autoComplete="new-password" minLength={12} required value={password} onChange={(event) => setPassword(event.target.value)} /></label><label className="login-password login-password-following" htmlFor="reset-confirm"><span>Повторите пароль</span><input id="reset-confirm" type="password" autoComplete="new-password" minLength={12} required value={confirm} onChange={(event) => setConfirm(event.target.value)} /></label></> : <label className="login-password" htmlFor="reset-email"><span>Email</span><input id="reset-email" type="email" autoComplete="email" required value={email} onChange={(event) => setEmail(event.target.value)} /></label>}{error ? <p role="alert" className="login-error">{error}</p> : null}<button type="submit" disabled={busy || Boolean(message) || (token ? password.length < 12 : !email)}><span>{busy ? 'Проверяем…' : token ? 'Сменить пароль' : 'Отправить ссылку'}</span><i aria-hidden>→</i></button><p className="login-security"><Link to="/login">Вернуться ко входу</Link></p></form></section></div>;
}
